export default __webpack_public_path__ + "static/media/after-cf.d5f6e9f1.png";